import Vue from 'vue';
import VueI18n from 'vue-i18n';

export const defaultLocale = 'nl';

Vue.use(VueI18n);

const messages = {
  en: require('../i18n/locales/en.json'),
  nl: require('../i18n/locales/nl.json'),
  de: require('../i18n/locales/de.json'),
  fr: require('../i18n/locales/fr.json'),
};

const getLocaleFromCookie = () => {
  const cookies = document.cookie.split(';');
  const djangoLanguageCookie = cookies.find(cookie => cookie.trim().startsWith('django_language='));
  const locale = djangoLanguageCookie ? djangoLanguageCookie.split('=')[1].trim() : null;
  return locale && messages[locale] ? locale : null;
};

const getLocaleFromBrowser = () => {
  const preferred = navigator.languages
    ? [...navigator.languages, navigator.language]
    : [navigator.language];

  for (const lang of preferred) {
    const code = lang.split('-')[0].toLowerCase();

    if (messages[code]) {
      return code;
    }
  }

  return null;
};

  /**
   * Determines the user's locale, prioritizing the Django language cookie and then browser settings.
   *
   * The preference order matches Django's language discovery process:
   * 1. Check for the 'django_language' cookie set by Django.
   * 2. If not found, fall back to browser's preferred languages.
   * 3. If still not found, use the default locale.
   *
   * @see https://docs.djangoproject.com/en/6.0/topics/i18n/translation/#how-django-discovers-language-preference
   */
const getLocale = () => {
  return getLocaleFromCookie() ?? getLocaleFromBrowser() ?? defaultLocale;
};

const i18n = new VueI18n({
  locale: getLocale(),
  fallbackLocale: defaultLocale,
  messages,
});

export default i18n;
